import React, { useState } from "react";
import { GoChevronDown } from "react-icons/go";
import Footer from "../components/modules/Footer/Footer";
import { FAQ_OPTIONS } from "../constants/faq";
import FooterMobile from "../components/modules/Footer/FooterMobile";

export default function Faq() {
  const [tt, setTt] = useState([]);
  return (
    <div className="relative  w-full  flex flex-col items-center justify-start bg-color-primary-A ">
      <div className="w-full max-w-[1440px] h-full flex flex-col items-center justify-start ">
        <div className="w-full max-w-[824px]  h-[72px] flex items-center justify-center gap-x-[4px] bg-[#FFF] rounded-[10px] p-[10px] cursor-pointer mt-[95px] ">
          <img src="../assets/images/other/Faq.svg" />
          <span className="font-font_primary_A font-bold text-[24px] min-[769px]:text-[40px] text-color-primary-D">
            سوالات متداول
          </span>
        </div>
        <div
          dir="rtl"
          className={`w-full max-w-[500px] min-[769px]:max-w-[1000px] px-[20px] min-[769px]:p-0  h-full flex flex-col items-start justify-start  gap-y-[15px]  overflow-auto  mt-[80px] mb-[154px] `}
        >
          {FAQ_OPTIONS.map((item, index) => {
            return (
              <div
                key={index}
                className="w-full flex flex-col items-center justify-center p-[8px] border-b-[1px] border-[#474747]  "
              >
                <div
                  className="w-full flex items-center justify-between "
                  onClick={() => {
                    if (tt.includes(index)) {
                      setTt(tt.filter((item) => item !== index));
                    } else {
                      setTt((prev) => [...prev, index]);
                    }
                  }}
                >
                  <div className="w-[95%] cursor-pointer">
                    <p className="w-full   font-font_primary_A text-[14px] min-[769px]:text-[20px] text-color-primary-D font-normal text-justify pl-[16px]   break-words">
                      {item.question}
                    </p>
                  </div>
                  <div
                    className={`w-[30px]  flex items-center justify-center cursor-pointer ${
                      tt.includes(index) ? "" : "rotate-90"
                    }`}
                  >
                    <GoChevronDown size={20} color="#10242b" />
                  </div>
                </div>
                {tt.includes(index) && (
                  <div className="w-full flex items-center justify-start pt-[4px] pr-0 btFadeIn-WithOutDelay">
                    <p className="w-full font-font_primary_A text-[12px] min-[769px]:text-[18px] text-color-primary-D font-extralight text-justify break-words">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <Footer />
      <FooterMobile/>
    </div>
  );
}
